var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('wklr-icon-btn',{staticClass:"share-fragment-button",attrs:{"type":"share","dense":true},on:{"click":_vm.copyFragmentInfo,"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }